export default __webpack_public_path__ + "static/media/about.06cbc9ca.png";